import React, { useState } from 'react';
import API from '../api/api';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';  // ✅ Import SweetAlert2
import "./AdminLogin.css";

const AdminLogin = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();

    try {
      const res = await API.post('/admin/login', form);

      // ✅ Save token & admin info
      localStorage.setItem('eseva_token', res.data.token);
      localStorage.setItem('eseva_admin', JSON.stringify(res.data.admin));

      // ✅ Success alert
      await Swal.fire({
        title: '✅ Login Successful!',
        text: `Welcome back, ${res.data.admin.name || 'Admin'}!`,
        icon: 'success',
        confirmButtonColor: '#fe6e03',
        timer: 1500,
        showConfirmButton: false,
      });

      navigate('/admin'); // redirect to admin dashboard
    } catch (error) {
      const message = error.response?.data?.message || 'Login failed. Please try again.';

      // ❌ Error alert
      Swal.fire({
        title: '❌ Login Failed',
        text: message,
        icon: 'error',
        confirmButtonColor: '#d33',
      });
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card shadow-lg">
        <h3 className="text-center mb-4 heading">Admin Login</h3>

        <form onSubmit={submit}>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input 
              className="form-control input-box"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              required 
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input 
              type="password"
              className="form-control input-box"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              required 
            />
          </div>

          <button className="btn login-btn w-100" type="submit">
            Login
          </button>
        </form>

        <Link to="/admin/forgot-password" className="forgot-link">
          Forgot Password?
        </Link>
      </div>
    </div>
  );
};

export default AdminLogin;
